
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ev-cars-chiang-mai",
      function () {
        return require("private-next-pages/ev-cars-chiang-mai.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ev-cars-chiang-mai"])
      });
    }
  